import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  Avatar, 
  Box,
  IconButton,
  Menu,
  MenuItem
} from '@mui/material';
import { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';

const AuthHeader = () => {
  const { user, isGuest, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const location = useLocation();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleClose();
  };

  const getPageTitle = () => {
    const path = location.pathname.replace(/\/$/, ''); // 末尾のスラッシュを削除
    switch (path) {
      case '/word_viewer':
        return '🔤 Word Viewer';
      case '/sentence_viewer':
        return '🎧 Sentence Viewer';
      case '/skit_viewer':
        return '💬 Skit Viewer';
      case '/ex2_viewer':
        return '📝 Ex.2 Viewer';
      case '/irregular_verbs':
        return '不規則動詞一覧';
      case '/uploader':
        return 'ファイルアップローダー';
      case '/homework_words':
        return '⌨️ 単語テスト';
      case '/pronunciation_lab':
        return '🎤 Pronunciation Lab';
      default:
        return 'ファイルアップローダー';
    }
  };

  return (
    <AppBar position="static" sx={{ marginBottom: 2 }}>
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          {getPageTitle()}
        </Typography>
        
        {isGuest && (
          <Button color="inherit" onClick={logout} sx={{ textTransform: 'none' }}>
            ログイン
          </Button>
        )}

        {user && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button 
              component={Link}
              to="/"
              color="inherit"
              sx={{ 
                textTransform: 'none',
                fontSize: '0.9rem'
              }}
            >
              ホーム
            </Button>
            
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <Avatar 
                src={user.picture} 
                alt={user.name}
                sx={{ width: 32, height: 32 }}
              />
            </IconButton>
          
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose} disabled>
                <Box>
                  <Typography variant="body2" fontWeight="bold">
                    {user.name}
                  </Typography>
                </Box>
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                ログアウト
              </MenuItem>
            </Menu>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default AuthHeader;